'use strict'

var App = require('app')

/* Views */
var List = require('./list')
var MapList = require('./map')
var Show = require('./show')
var Edit = require('./edit')
var Control = require('./control')
var Emergency = require('./emergency')
var Register = require('./register')

var DevicesModule = function () {
  var Router = App.PermissionAppRouter.extend({
    appRoutes: {
      'device/:id': 'showDevice'
    }
  })

  /* API -------------------------------------------------------------------- */
  var API = {
    showDevice: function (id, device) {
      new Show({
        id: id,
        device: device
      })
    },
    editDevice: function (options) {
      new Edit(options)
    },
    listDevices: function (options) {
      var list = new List()
      list.listDevices(options)
    },
    mapDevices: function (options) {
      var mapList = new MapList()
      mapList.listDevices(options)
    },
    controlDevice: function (options) {
      new Control(options)
    },
    emergency: function (options) {
      new Emergency(options)
    },
    register: function (options) {
      new Register(options)
    },
  }

  /* Listeners -------------------------------------------------------------- */
  App.globalChannel.on('device:show', function (options) {
    App.globalChannel.trigger('app:navigate', 'device/' + options.model.id) // update the url
    API.showDevice(options.model.id, options.model)
  })

  App.globalChannel.on('device:edit', function (options) {
    API.editDevice(options)
  })

  App.globalChannel.on('device:new', function (options) {
    API.editDevice(options)
  })


  App.globalChannel.on('devices:list', function (options) {
    API.listDevices(options)
  })

  App.globalChannel.on('devices:map', function (options) {
    API.mapDevices(options)
  })

  App.globalChannel.on('device:control', function (options) {
    API.controlDevice(options)
  })

  App.globalChannel.on('devices:emergency', function (options) {
    API.emergency({region: App.rootLayout.getRegion('dialogRegion')})
  })

  App.globalChannel.on('device:register', function (options) {
    API.register(options)
  })

  // fire this up on an global app event
  new Router({ controller: API })
}

module.exports = DevicesModule



// WEBPACK FOOTER //
// ./js/modules/devices/index.js